import React, { useState } from 'react';
import loadable from '@loadable/component';
import bemCn from 'bem-cn';
import { Slide, ToastContainer } from 'react-toastify';
import { AUTH_MODAL_STATES } from '../../consts/auth-modal.consts';
import ModalMobile from '../../components/modal-mobile';
import SvgCross2 from 'src/assets/svg/SvgCross2.svg';
import 'react-toastify/dist/ReactToastify.css';

const RenderSignUpEmail = loadable(() => import('../../pages/host-landing/render-sign-up-email'));

const bSignUp = bemCn('host-landing');

const BlurSignupModal = ({ isBlurTest, setIsBlurTest, isMobile, useStateSSR, spotDetail }) => {
    const useStateClient = useStateSSR || useState;
    const [isFocused, setIsFocused] = useStateClient(false);

    // New state variables for single auth modal
    const [modalState, setModalState] = useState(AUTH_MODAL_STATES.EMAIL_INPUT);
    const [userEmail, setUserEmail] = useState('');
    const [emailCheckLoading, setEmailCheckLoading] = useState(false);

    // Reset modal state when modal closes
    const handleModalClose = () => {
        setIsFocused(false);
        setIsBlurTest(false);
        // Reset single auth modal state
        setModalState(AUTH_MODAL_STATES.EMAIL_INPUT);
        setUserEmail('');
        setEmailCheckLoading(false);
    };

    return (
        <ModalMobile
            isBlur
            isCentered={!isMobile}
            isOpen={!!isBlurTest}
            toggle={handleModalClose}
            contentClassName={isMobile ? 'border-radius-10' : ''}
        >
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable
                pauseOnHover={false}
                theme="colored"
                transition={Slide}
                limit={3}
                style={{ zIndex: 10000 }}
            />
            <p
                style={{ top: isFocused ? '-5%' : '-8%', right: '8px', cursor: 'pointer' }}
                className="position-absolute text-end snif-p snif-regular mb-0 text-white"
                onClick={handleModalClose}
            >
                <span>Close</span> <SvgCross2 />
            </p>
            <p className="snif-m1 snif-semibold text-center mb-3">Create a free account</p>
            <p className="snif-s1 text-medium text-center mb-3">You need to sign up or sign in before continuing</p>
            <RenderSignUpEmail
                {...{
                    b: bSignUp,
                    signUp: true,
                    isFocused,
                    setIsFocused,
                    from: typeof window === 'undefined' ? '' : window.location.href,
                    showOptions: true,
                    useStateSSR: useState,
                    // New single auth modal props
                    modalState,
                    setModalState,
                    userEmail,
                    setUserEmail,
                    emailCheckLoading,
                    setEmailCheckLoading,
                    afterSignUp: (re_uri = '') => {
                        setIsBlurTest(false);
                        if (spotDetail) {
                            if (re_uri.includes('subscriptions')) {
                                const newUrl = window.location.pathname + '?redir=' + encodeURIComponent(re_uri);
                                window.open(newUrl, '_self');
                                return;
                            } else {
                                window.open(re_uri, '_self');
                            }
                            setTimeout(() => {
                                if (re_uri.startsWith(window.location.pathname)) {
                                    window.location.reload();
                                }
                            }, 150);
                        } else {
                            window.location = re_uri;
                            setTimeout(() => {
                                if (re_uri && re_uri.includes('#')) {
                                    window.location.reload();
                                }
                            }, 100);
                        }
                    },
                }}
            />
        </ModalMobile>
    );
};

export default BlurSignupModal;
